var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { cloneDeep } from 'lodash';
import Erasure from 'sunzi-plugin-erasure';
import { Header, Icon, Wrapper } from '@mademine/components';
import { I18n, Gtag } from '@mademine/utils';
import styles from './style.module.less';
import { getFaceData, loadHTMLImage } from '../../utils';
import { ReactComponent as IconClose } from '../../assets/icon-arrow-bold-close.svg';
import { ReactComponent as IconCheck } from '../../assets/ic-check.svg';
import { ReactComponent as IconWithdraw } from '../../assets/icon-line-tool-withdraw.svg';
import { ReactComponent as IconRubber } from '../../assets/ic-rubber.svg';
import { ReactComponent as IconCut } from '../../assets/ic-cut.svg';
import { ReactComponent as IconPhoto } from '../../assets/ic-photo.svg';
import { ReactComponent as IconLeft } from '../../assets/icon-arrow-bold-left.svg';
import { useData } from '../../hooks/useData';
var Edit = function (_a) {
    var _b, _c, _d, _e;
    var images = _a.images, setImages = _a.setImages, setZuploaderVisible = _a.setZuploaderVisible, setClipVisible = _a.setClipVisible, onShowLoading = _a.onShowLoading, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var _f = useData(), peopleIndex = _f.peopleIndex, currentSide = _f.currentSide;
    var _canvas = useRef(null);
    var _erasure = useRef();
    var _g = useState(false), erasureVisible = _g[0], setErasureVisible = _g[1];
    var _h = useState(true), revokeDisabled = _h[0], setRevokeDisabled = _h[1];
    useEffect(function () {
        var canvas = _canvas.current;
        if (canvas) {
            var offsetWidth = canvas.offsetWidth, offsetHeight = canvas.offsetHeight;
            var scale = Math.min(1000 / offsetWidth, 1000 / offsetHeight);
            canvas.width = offsetWidth * scale;
            canvas.height = offsetHeight * scale;
            loadHTMLImage(images[peopleIndex][currentSide - 1].image).then(function (image) {
                _erasure.current = new Erasure(canvas, image, {
                    padding: 60,
                    color: 'rgba(255, 0, 0, 0.5)',
                    onStackChange: function (stack) {
                        if (stack.length === 0 && !revokeDisabled)
                            setRevokeDisabled(true);
                        else if (stack.length > 0 && revokeDisabled)
                            setRevokeDisabled(false);
                    }
                });
                _erasure.current.modeToggle();
            });
        }
    }, []);
    var handleErasureVisible = function (visible) {
        var _a;
        setErasureVisible(visible);
        (_a = _erasure.current) === null || _a === void 0 ? void 0 : _a.modeToggle();
        if (visible)
            Gtag.event('event_erasure_open');
        else
            Gtag.event('event_erasure_close');
    };
    var handleErasureClosed = function () {
        var _a;
        (_a = _erasure.current) === null || _a === void 0 ? void 0 : _a.reset();
        handleErasureVisible(false);
    };
    var handleErasureConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canvas;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    canvas = (_a = _erasure.current) === null || _a === void 0 ? void 0 : _a._canvas;
                    onShowLoading(canvas.toDataURL());
                    return [4, new Promise(function (resolve) {
                            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var result, _a, htmlImage, faceRecognizeData, sideIndex, image, newImage, newImages;
                                var _b, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            onClose();
                                            return [4, ((_b = _erasure.current) === null || _b === void 0 ? void 0 : _b.toErasureURL())];
                                        case 1:
                                            result = _d.sent();
                                            if (!result) return [3, 3];
                                            return [4, Promise.all([
                                                    loadHTMLImage(result),
                                                    getFaceData(result)
                                                ])];
                                        case 2:
                                            _a = _d.sent(), htmlImage = _a[0], faceRecognizeData = _a[1];
                                            sideIndex = currentSide - 1;
                                            image = images[peopleIndex][sideIndex];
                                            newImage = __assign({}, image);
                                            newImage.image = result;
                                            newImage.height = htmlImage.height;
                                            newImage.width = htmlImage.width;
                                            newImage.faceRecognizeData = faceRecognizeData;
                                            newImages = cloneDeep(images);
                                            newImages[peopleIndex][sideIndex] = newImage;
                                            setImages(newImages);
                                            (_c = _erasure.current) === null || _c === void 0 ? void 0 : _c.dispose();
                                            Gtag.event('event_erasure_confirm');
                                            _d.label = 3;
                                        case 3:
                                            onShowLoading();
                                            resolve();
                                            return [2];
                                    }
                                });
                            }); }, 300);
                        })];
                case 1:
                    _b.sent();
                    return [2];
            }
        });
    }); };
    return (_jsx(Wrapper, { className: styles['edit-wrapper'], children: _jsxs("div", { className: styles.edit, children: [_jsx(Header, { className: classnames('!_sz-border-none', styles['edit-header'], (_b = {},
                        _b[styles['edit-header-hide']] = erasureVisible,
                        _b)), onClose: onClose, renderCloseContent: _jsx("div", { className: "_sz-p-1.5", onClick: onClose, children: _jsx(Icon, { size: 24, color: "rgba(0, 0, 0, 0.88)", children: _jsx(IconLeft, {}) }) }), renderContent: _jsx("span", { className: "".concat(styles['edit-header-content'], " _sz-text-base _sz-font-extrabold _sz-text-black/[.88]"), children: I18n.format('modules.mini.me.edit.title') }), renderConfirmContent: _jsx("button", { type: "button", className: "".concat(styles['edit-header-submit'], " _sz-mr-4 _sz-h-9 _sz-rounded _sz-bg-black _sz-px-4 _sz-py-2 _sz-text-base _sz-font-black _sz-text-white"), onClick: onConfirm, children: I18n.format('modules.global.done') }) }), _jsxs("div", { className: classnames(styles['erasure-button-group'], styles['erasure-button-group-hide'], (_c = {},
                        _c[styles['erasure-button-group-show']] = erasureVisible,
                        _c)), children: [_jsx("div", { className: styles['button-group'], children: _jsx("div", { className: styles['erasure-close'], onClick: handleErasureClosed, children: _jsx(Icon, { size: 30, color: "#191919", children: _jsx(IconClose, {}) }) }) }), _jsx("div", { className: styles['erasure-confirm'], onClick: handleErasureConfirm, children: _jsx(Icon, { size: 30, color: "#fff", children: _jsx(IconCheck, {}) }) })] }), _jsx("div", { className: styles['edit-content'], children: _jsx("canvas", { ref: _canvas }) }), _jsx("div", { className: classnames(styles['erasure-button-group'], (_d = {},
                        _d[styles['erasure-button-group-down']] = erasureVisible,
                        _d['!_sz-justify-center'] = erasureVisible,
                        _d)), children: erasureVisible ? (_jsx("div", { className: styles['button-group'], children: _jsx("div", { className: styles['erasure-revoke'], onClick: function () { var _a; return (_a = _erasure.current) === null || _a === void 0 ? void 0 : _a.revoke(); }, children: _jsx(Icon, { size: 30, color: revokeDisabled ? '#191919' : '#000', className: revokeDisabled ? '_sz-opacity-10' : '', children: _jsx(IconWithdraw, {}) }) }) })) : (_jsx("div", { className: styles['erasure-button'], onClick: function () { return handleErasureVisible(true); }, children: _jsx(Icon, { size: 28, color: "#191919", children: _jsx(IconRubber, {}) }) })) }), _jsxs("div", { className: classnames(styles.footer, (_e = {},
                        _e[styles['footer-hide']] = erasureVisible,
                        _e)), children: [_jsxs("div", { className: styles.button, onClick: function () { return setZuploaderVisible(true); }, children: [_jsx(Icon, { size: 28, color: "#191919", children: _jsx(IconPhoto, {}) }), _jsx("span", { children: I18n.format('modules.global.replace') })] }), _jsxs("div", { className: styles.button, onClick: function () { return setClipVisible(true); }, children: [_jsx(Icon, { size: 28, color: "#191919", children: _jsx(IconCut, {}) }), _jsx("span", { children: I18n.format('modules.global.cropper') })] })] })] }) }));
};
export default Edit;
